import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { APIURLConstantsService } from '../services/api-url-service/apiurlconstants.service';

import { IFROportunitats } from '../oportunitats/oportunitats.interfaces';
import { IFRNotes, IFRNota } from './notes.interfaces';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class NotesService {
  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  private _API_BASE_URL: string = environment['API_URL'];

  public get(usuari, filters = {}, conds = {}, ordering = {}): Observable<IFRNotes[]> {
   let params = new HttpParams();
  
    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString().replace(/\+/g,"%2B")));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<IFRNotes[]>(this._API_BASE_URL + 'quefaig/'+usuari, this.options)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public getNotes(id): Observable<IFRNotes[]> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(this._API_BASE_URL + 'notes/' + id, this.options)
      .pipe(map(response => response || []));
  }

  public updateNota(data): Observable<any> {    
    return this.authHttp.put(this._API_BASE_URL + 'nota/'+(data.codi?data.codi:data.id), data)
      .pipe(map(response => response || {}));
  }
  
  public deleteNota(id): Observable<any> {
    return this.authHttp.delete(this._API_BASE_URL + 'nota/'+id)
      .pipe(map(response => response || {}));
  }

  public getAutocomplete(id: string, codi: string): Observable<Array<{value: string, text: string}>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocompletecodi/' + id + "/codi/" + codi)
    .pipe(map(response => response || []));
  }

  
  constructor(private authHttp: HttpClient) { }

}
